import React, { useState } from "react";
import { useParams } from "react-router-dom";
import useLanguage from "../hooks/useLanguage";
import A from "../utils/url.utils";
import axios from "axios";
import { useRecoilValue } from "recoil";
import { callSettingsAtom, settingsAtom } from "../state";
import CopyButton from "./common/CopyButton";
import RefreshButton from "./common/RefreshButton";
import U, { PROFESSIONALCANCELLED } from "../utils/utils.js";
import { NoData } from "./common/NoData.jsx";
import { SmallLoader } from "./common/SmallLoader.jsx";
import GoogleMapComponent from "./GoogleMapComponent.jsx";
import useTheme from "../hooks/useTheme.jsx";
import { useThemes } from "../contexts/ThemeContext.js";
import useUtils from "../hooks/useUtils.jsx";
import { format } from "date-fns";
import StarRating from "./common/StarRating.jsx";
import useImage from "../hooks/useImage.jsx";
import Switch from "./common/Switch.jsx";
import TrackingMap from "./TrackingMap.jsx";
import NotFound from "./common/NotFound.jsx";

const EstimationDetails = ({
  ride,
  estimationBefore,
  estimationAfter,
  switchValue,
}) => {
  const { language } = useLanguage();
  const settings = useRecoilValue(settingsAtom);

  const { morph, calculateDistanceUnit, formatTimeFromSeconds } = useUtils();
  const { theme } = useTheme();
  const { themes, currentTheme } = useThemes();
  const themeT = themes[currentTheme];

  const rideStopsArray = estimationBefore
    ? ride?.rideStops
    : estimationAfter
      ? ride?.activity?.rideStops
      : [];

  return (
    <>
      <section className="mt-3 lg:px-8  px-0">
        <div className={` w-full h-full`}>
          <div>
            <p className=" capitalize mt-5">{ride?.category?.locationName}</p>
            {/* below heading type status category */}
            <div
              className="flex flex-wrap  items-center gap-4 mt-2"
              style={{ fontSize: "15px" }}
            >
              <span className=" rounded-lg capitalize bg-emerald-600 px-3 py-1.5 text-[13.5] text-white">
                {(language[ride?.bookingType]?.toLowerCase() ||
                  ride?.bookingType?.toLowerCase()) +
                  " " +
                  (language?.[ride?.serviceCategory] || ride?.serviceCategory)}
              </span>
              {estimationAfter && (
                <span
                  className="rounded-full border"
                  style={{
                    borderColor:
                      ride?.bookingStatus === "USERCANCELLED" ||
                      ride?.bookingStatus === "PROFESSIONALCANCELLED" ||
                      ride?.bookingStatus === "EXPIRED" ||
                      ride?.bookingStatus === "USERDENY"
                        ? "#e53935"
                        : "#50C878",
                    color:
                      ride?.bookingStatus === "USERCANCELLED" ||
                      ride?.bookingStatus === "PROFESSIONALCANCELLED" ||
                      ride?.bookingStatus === "EXPIRED" ||
                      ride?.bookingStatus === "USERDENY"
                        ? "#d32f2f"
                        : "#50C878",
                    padding: "5px 10px",
                    width: "fit-content",
                    fontSize: "13.5px",
                  }}
                >
                  {ride?.bookingStatus === "AWAITING"
                    ? language.REQUESTING
                    : language[ride?.bookingStatus] || ride?.bookingStatus}
                </span>
              )}
              {
                <div className="flex items-center gap-1">
                  {ride?.vehicle?.vehicleCategoryImage && (
                    <div
                      className=" "
                      style={{
                        width: "60px",
                        height: "50px",
                        marginRight: "4px",
                      }}
                    >
                      <img
                        src={ride?.vehicle?.vehicleCategoryImage}
                        alt="Driver"
                        className="w-full h-full rounded-full object-contain"
                      />
                    </div>
                  )}
                  <p style={{ fontSize: "15px" }}>
                    {ride?.vehicle?.vehicleCategoryName || "-"}
                  </p>
                </div>
              }
            </div>

            {/* date */}
            <div className="mt-4 flex items-center gap-3 ml-1 text-[15px]">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <title>Calendar</title>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M23 8V4h-3V1h-3v3H7V1H4v3H1v4h22Zm0 15H1V10h22v13ZM8 14H5v3h3v-3Z"
                  fill="currentColor"
                ></path>
              </svg>
              <p className="">
                {" "}
                {ride?.bookingStatus === "AWAITING" ? (
                  <>
                    <span>
                      {format(new Date(ride?.bookingDate), "MMM d, yyyy")}
                    </span>{" "}
                    {language.AT}{" "}
                    <span>{format(new Date(ride?.bookingDate), "p")}</span>
                  </>
                ) : (
                  <>
                    <span>
                      {format(
                        new Date(ride?.activity?.bookingTime),
                        "MMM d, yyyy",
                      )}
                    </span>{" "}
                    {language.AT}{" "}
                    <span>
                      {format(new Date(ride?.activity?.bookingTime), "p")}
                    </span>
                  </>
                )}
              </p>
            </div>

            {/* Locations */}
            <div className="relative mt-4 w-full">
              {rideStopsArray?.length > 0 &&
                rideStopsArray?.map((eachRide, i) => (
                  <div
                    className={`flex flex-col lg:flex-row lg:justify-between items-start gap-2 lg:gap-4 lg:px-2 w-full ${
                      eachRide?.type !== "ORIGIN" && "mt-5"
                    } `}
                    key={i}
                  >
                    <div className="flex items-start gap-4 px-2 w-full">
                      <div className="relative">
                        <div className=" rounded-full border-2  mt-2 h-[10px] w-[10px] border-green-600"></div>
                        {eachRide?.type !== "DESTINATION" && (
                          <div className="absolute top-4 left-0 border-dashed border-l-2  mt-2 h-[57px] w-[9px] border-green-600 ml-[4px]"></div>
                        )}
                      </div>
                      <div className="" style={{ marginLeft: "1px" }}>
                        <p className="text-xs">
                          {eachRide?.type === "ORIGIN"
                            ? language.PICKUP
                            : eachRide?.type === "DESTINATION"
                              ? language.DROP
                              : `${language.STOP} - ${i}`}
                        </p>
                        <p className=" font-semibold break-words capitalize lg:max-w-[23vw]">
                          {eachRide?.shortAddress}
                        </p>
                        <p className=" font-light text-sm  break-words capitalize lg:max-w-[23vw]">
                          {morph(eachRide?.fullAddress)}
                        </p>
                      </div>
                    </div>
                    <div>
                      {estimationAfter && eachRide?.type === "ORIGIN" && (
                        <div
                          className="lg:ml-auto ml-8 w-[155px] break-words"
                          style={{ fontSize: "14.5px" }}
                        >
                          <p className="">
                            {format(
                              new Date(ride.activity.pickUpTime),
                              "MMM d yyyy, p",
                            )}
                          </p>
                        </div>
                      )}
                      {estimationAfter &&
                        eachRide?.type === "STOP" &&
                        ride?.activity?.stopTime?.length > 0 && (
                          <div
                            className="lg:ml-auto ml-8 break-words"
                            style={{ width: "155px", fontSize: "14.5px" }}
                          >
                            <p className="  ">
                              {format(
                                new Date(ride?.activity?.stopTime[i - 1]),
                                "MMM d yyyy, p",
                              )}
                            </p>
                          </div>
                        )}
                      {estimationAfter && eachRide?.type === "DESTINATION" && (
                        <div
                          className="lg:ml-auto ml-8 break-words"
                          style={{ width: "155px", fontSize: "14.5px" }}
                        >
                          <p className="ml-auto">
                            {format(
                              new Date(ride.activity.dropTime),
                              "MMM d yyyy, p",
                            )}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
            </div>

            {/* distance time Pill */}
            {/* {ride?.bookingStatus === "ENDED" && switchValue && (
              <div
                className={`grid grid-cols-3 items-center divide-x mt-5 ${themeT?.colors?.blocksBg} ${themeT?.colors?.shadow}  ${themeT.colors.divideColor} rounded-full  text-sm lg:text-[14px] w-full `}
              >
                <p className="flex items-center ">
                  <span>
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 512 512"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M92.6 21c-32 0-64.04 24-64.04 72L92.6 221l64-128c0-48-32-72-64-72zm282.3 39c-6.9.29-13.6 1.6-19.2 2.8l3.8 17.6c5.6-1.25 11.4-2.04 16.3-2.4zM92.6 61c17.7 0 32 14.33 32 32 0 17.7-14.3 32-32 32-17.67 0-32-14.3-32-32 0-17.67 14.33-32 32-32zm302.2.2l-3 17.7c4.9 1.03 9.8 2.32 14.1 4.9l8.7-15.8c-6.1-3.25-12.9-6.17-19.8-6.8zm-57.5 6.7c-6.1 2.38-12.2 4.51-17.4 6.6L327 91c5.5-2.34 11.3-4.38 16.2-6.1zM431 81.3L417.3 93c3.6 4.12 6.4 9.2 8.6 13.3l16.1-8.1c-3.4-6.55-6.4-11.51-11-16.9zm-127.8.9c-6.1 3.11-11.1 5.88-16.5 8.6l8.8 15.8c5.2-3 10.9-5.9 15.5-8.2zm-32.3 17.9c-5.3 3.1-10.5 6.2-15.6 9.6l9.8 15c4.9-3.2 10-6.2 15-9.2zM448.2 118c-5.9 1-11.9 1.7-17.8 2.4.4 5 .1 10.4-.9 14.6l17.5 4.1c1-7.2 1.9-14.6 1.2-21.1zm-208.1 1.7c-5 3.4-9.9 6.9-14.9 10.3l10.4 14.7c4.8-3.5 9.7-6.8 14.6-10.2zm-29.6 21.1c-5 3.6-10.2 7.6-14.5 10.9l10.9 14.3c5.5-4 9.3-7 14.3-10.7zm213 8c-3 4.6-6.5 9.2-10 12.7l13.1 12.5c4.3-5.1 8.9-10.3 12.1-15.5zm-241.8 14.1c-4.9 3.8-9.8 7.7-14.1 11.3l11.4 13.9c4.7-3.9 9.5-7.9 13.9-11.1zM401.1 173c-4.6 3.7-9.4 7.3-13.8 10.3l10.3 14.8c5.3-3.6 10.5-7.5 15-11.1zm-247.4 12.9c-4.7 3.8-9.2 7.8-13.8 11.7l11.7 13.7c4.5-3.9 9-7.8 13.6-11.6zm218.9 7c-5.1 3-10.4 6.1-15.2 8.7l8.6 15.9c5.4-3.3 11.5-6.2 16-9.2zm-246.4 16.6c-4.5 4-8.9 8-13.4 12.1l12.1 13.4c4.4-4 8.9-8 13.3-12zm215.5.4c-5.3 2.6-10.6 5.3-15.9 7.9l7.7 16.2c6.2-3 10.8-5.5 16.4-8.1zm-32 15.4c-5.5 2.5-10.8 4.9-16.4 7.2l7.3 16.5c5.5-2.4 11-4.9 16.5-7.4zM99.6 234c-5.1 4.5-8.65 8-13.3 12.5l12.7 13c4.7-4.5 8.5-8.4 12.9-12.2zm177.3 5.8c-5.5 2.3-11 4.7-16.5 7l7 16.7c5.6-2.3 11.1-4.7 16.6-7.1zm-33.1 14c-5.5 2.4-11 4.8-16.6 7l7 16.7c5.5-2.3 11.1-4.7 16.6-7zm184.8 7.2c-32 0-64 24-64 72l64 128 64-128c0-48-32-72-64-72zm-218 6.8c-5.7 2.6-11.7 5-16.6 7.1l7.1 16.6c5.9-2.5 11.5-4.9 16.5-7.1zM177.4 282c-5.4 2.5-11.7 5.3-16.5 7.5l7.4 16.4c5.9-2.6 11.1-5.2 16.3-7.4zm-33 15c-5.6 2.7-11.4 5.5-16.4 8l8.1 16.1c5.4-2.8 11-5.4 15.9-7.8zm284.2 4c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-316.8 12.3c-5.3 2.9-10.6 5.9-16 9l9 15.6c5.1-3 10.3-5.8 15.5-8.6zM80.1 332c-5.61 3.2-11.03 7.5-15.7 10.6L75.3 357c4.97-3.6 10.32-7.3 14.6-9.9zm-29.9 22.6c-4.8 4.4-9.53 9.5-13.2 13.8l13.7 11.7c3.85-4.7 7.2-8.2 11.7-12.2zm217.8 1.3l1.6 17.9c5.2-.9 10.4-.3 15.6.5l3.1-17.7c-6.6-1-13.6-1.7-20.3-.7zm-37.2 10l6.8 16.7c5.2-2.3 10.6-4.1 16.1-5.8-1.9-5.7-3.3-11.5-4.8-17.3-6.3 1.8-12.6 4.2-18.1 6.4zm77.5-.9l-10.2 14.8c4.2 3.1 8.3 6.4 11.6 10.5l13.6-11.8c-5.1-5.2-9-10.1-15-13.5zm-94.5 9c-5.5 2.8-10.8 6-16.1 9.1l9.1 15.5c5.2-2.8 10.3-6.1 15.4-8.8zM26.01 385c-3.02 6.5-5.47 13.5-6.61 19.7l17.7 3.1c1.08-5.7 2.63-9.8 4.9-14.7-5.49-2.4-10.73-5.3-15.99-8.1zm156.09 7.8c-5.1 3.3-10.1 6.6-15.1 10l10 15c5-3.3 9.9-6.7 14.9-10zm152.7 1.2l-15.1 9.8c3.2 4.8 6.3 9.8 9.2 14.9l15.6-9c-3.5-5.6-6-10.6-9.7-15.7zm-182.7 19c-5 3.3-10 6.5-14.9 10l10 15c4.8-3.5 9.9-6.8 15-10.2zm-114.8 9.5c-5.79 1.2-11.63 2.2-17.45 3.3 1.05 7 3.86 13.8 6.4 19.2l16.25-7.8c-2.17-5-4.23-10.2-5.2-14.7zm316.1 2.8l-15.6 9c3.1 5.4 6.7 11.2 9.6 15.8l15.1-9.7c-3.4-5.3-6.3-10.3-9.1-15.1zm-231 7.5c-5 3.1-9.9 6.1-15.1 9l8.9 15.7c5.3-3.1 10.6-6.2 15.7-9.5zm-71.3 16.3l-12.3 13.2c5.56 5.3 12.42 8.8 19.9 10.4l4-17.5c-4.44-.9-8.59-3.1-11.6-6.1zm41 .3c-5.01 2.3-10.21 4.1-15.6 5.2l4.1 17.6c6.42-1.3 12.46-3.7 18.5-6.2zm280.3 4.8l-13.9 11.3c4.3 5.3 9.6 10.4 14.2 14l11.1-14.2c-4.4-3.4-8.2-7.5-11.4-11.1zm24.1 17.5l-4.5 17.5c7.9 1.6 13.8 2.1 21.2 1.3l-2.2-17.9c-4.9.8-9.7.3-14.5-.9z"></path>
                    </svg>
                  </span>
                  <span className="ml-2">
                    {estimationBefore
                      ? calculateDistanceUnit(
                          ride?.bookedEstimation?.distance,
                          ride?.distanceUnit,
                        )
                      : calculateDistanceUnit(
                          ride?.estimation?.distance,
                          ride?.distanceUnit,
                        )}
                  </span>
                </p>

                <p className="flex items-center ">
                  <span>
                    <svg
                      stroke="currentColor"
                      fill="none"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12"></polyline>
                    </svg>
                  </span>
                  <span className="ml-2">
                    {estimationBefore
                      ? parseFloat(ride?.bookedEstimation?.time / 60)?.toFixed(
                          2,
                        ) +
                        " " +
                        "min"
                      : parseFloat(ride?.estimation?.time / 60)?.toFixed(2) +
                        " " +
                        "min"}
                  </span>
                </p>

                <p className="flex items-center gap-3">
                  <span>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <title>Payment</title>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1 4h22v4H1V4Zm0 7h22v9H1v-9Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </span>
                  <div>
                    <p>
                      {ride?.currencySymbol}{" "}
                      {parseFloat(ride.invoice.payableAmount).toFixed(2)}
                    </p>
                    <p
                      className="text-gray-500 font-light "
                      style={{ fontWeight: 300, fontSize: "14px" }}
                    >
                      {" "}
                      {ride?.payment?.option}
                    </p>
                  </div>
                </p>
              </div>
            )} */}

            {/* distance time Pill */}
            <div
              className={`grid grid-cols-3 items-center  mt-5 ${themeT?.colors?.blocksBg} ${themeT?.colors?.shadow}  ${themeT.colors.divideColor} rounded-full py-3 px-2 text-sm lg:text-[14px] w-full`}
            >
              <p className="flex items-center justify-center gap-3">
                <span>
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 512 512"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M92.6 21c-32 0-64.04 24-64.04 72L92.6 221l64-128c0-48-32-72-64-72zm282.3 39c-6.9.29-13.6 1.6-19.2 2.8l3.8 17.6c5.6-1.25 11.4-2.04 16.3-2.4zM92.6 61c17.7 0 32 14.33 32 32 0 17.7-14.3 32-32 32-17.67 0-32-14.3-32-32 0-17.67 14.33-32 32-32zm302.2.2l-3 17.7c4.9 1.03 9.8 2.32 14.1 4.9l8.7-15.8c-6.1-3.25-12.9-6.17-19.8-6.8zm-57.5 6.7c-6.1 2.38-12.2 4.51-17.4 6.6L327 91c5.5-2.34 11.3-4.38 16.2-6.1zM431 81.3L417.3 93c3.6 4.12 6.4 9.2 8.6 13.3l16.1-8.1c-3.4-6.55-6.4-11.51-11-16.9zm-127.8.9c-6.1 3.11-11.1 5.88-16.5 8.6l8.8 15.8c5.2-3 10.9-5.9 15.5-8.2zm-32.3 17.9c-5.3 3.1-10.5 6.2-15.6 9.6l9.8 15c4.9-3.2 10-6.2 15-9.2zM448.2 118c-5.9 1-11.9 1.7-17.8 2.4.4 5 .1 10.4-.9 14.6l17.5 4.1c1-7.2 1.9-14.6 1.2-21.1zm-208.1 1.7c-5 3.4-9.9 6.9-14.9 10.3l10.4 14.7c4.8-3.5 9.7-6.8 14.6-10.2zm-29.6 21.1c-5 3.6-10.2 7.6-14.5 10.9l10.9 14.3c5.5-4 9.3-7 14.3-10.7zm213 8c-3 4.6-6.5 9.2-10 12.7l13.1 12.5c4.3-5.1 8.9-10.3 12.1-15.5zm-241.8 14.1c-4.9 3.8-9.8 7.7-14.1 11.3l11.4 13.9c4.7-3.9 9.5-7.9 13.9-11.1zM401.1 173c-4.6 3.7-9.4 7.3-13.8 10.3l10.3 14.8c5.3-3.6 10.5-7.5 15-11.1zm-247.4 12.9c-4.7 3.8-9.2 7.8-13.8 11.7l11.7 13.7c4.5-3.9 9-7.8 13.6-11.6zm218.9 7c-5.1 3-10.4 6.1-15.2 8.7l8.6 15.9c5.4-3.3 11.5-6.2 16-9.2zm-246.4 16.6c-4.5 4-8.9 8-13.4 12.1l12.1 13.4c4.4-4 8.9-8 13.3-12zm215.5.4c-5.3 2.6-10.6 5.3-15.9 7.9l7.7 16.2c6.2-3 10.8-5.5 16.4-8.1zm-32 15.4c-5.5 2.5-10.8 4.9-16.4 7.2l7.3 16.5c5.5-2.4 11-4.9 16.5-7.4zM99.6 234c-5.1 4.5-8.65 8-13.3 12.5l12.7 13c4.7-4.5 8.5-8.4 12.9-12.2zm177.3 5.8c-5.5 2.3-11 4.7-16.5 7l7 16.7c5.6-2.3 11.1-4.7 16.6-7.1zm-33.1 14c-5.5 2.4-11 4.8-16.6 7l7 16.7c5.5-2.3 11.1-4.7 16.6-7zm184.8 7.2c-32 0-64 24-64 72l64 128 64-128c0-48-32-72-64-72zm-218 6.8c-5.7 2.6-11.7 5-16.6 7.1l7.1 16.6c5.9-2.5 11.5-4.9 16.5-7.1zM177.4 282c-5.4 2.5-11.7 5.3-16.5 7.5l7.4 16.4c5.9-2.6 11.1-5.2 16.3-7.4zm-33 15c-5.6 2.7-11.4 5.5-16.4 8l8.1 16.1c5.4-2.8 11-5.4 15.9-7.8zm284.2 4c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-316.8 12.3c-5.3 2.9-10.6 5.9-16 9l9 15.6c5.1-3 10.3-5.8 15.5-8.6zM80.1 332c-5.61 3.2-11.03 7.5-15.7 10.6L75.3 357c4.97-3.6 10.32-7.3 14.6-9.9zm-29.9 22.6c-4.8 4.4-9.53 9.5-13.2 13.8l13.7 11.7c3.85-4.7 7.2-8.2 11.7-12.2zm217.8 1.3l1.6 17.9c5.2-.9 10.4-.3 15.6.5l3.1-17.7c-6.6-1-13.6-1.7-20.3-.7zm-37.2 10l6.8 16.7c5.2-2.3 10.6-4.1 16.1-5.8-1.9-5.7-3.3-11.5-4.8-17.3-6.3 1.8-12.6 4.2-18.1 6.4zm77.5-.9l-10.2 14.8c4.2 3.1 8.3 6.4 11.6 10.5l13.6-11.8c-5.1-5.2-9-10.1-15-13.5zm-94.5 9c-5.5 2.8-10.8 6-16.1 9.1l9.1 15.5c5.2-2.8 10.3-6.1 15.4-8.8zM26.01 385c-3.02 6.5-5.47 13.5-6.61 19.7l17.7 3.1c1.08-5.7 2.63-9.8 4.9-14.7-5.49-2.4-10.73-5.3-15.99-8.1zm156.09 7.8c-5.1 3.3-10.1 6.6-15.1 10l10 15c5-3.3 9.9-6.7 14.9-10zm152.7 1.2l-15.1 9.8c3.2 4.8 6.3 9.8 9.2 14.9l15.6-9c-3.5-5.6-6-10.6-9.7-15.7zm-182.7 19c-5 3.3-10 6.5-14.9 10l10 15c4.8-3.5 9.9-6.8 15-10.2zm-114.8 9.5c-5.79 1.2-11.63 2.2-17.45 3.3 1.05 7 3.86 13.8 6.4 19.2l16.25-7.8c-2.17-5-4.23-10.2-5.2-14.7zm316.1 2.8l-15.6 9c3.1 5.4 6.7 11.2 9.6 15.8l15.1-9.7c-3.4-5.3-6.3-10.3-9.1-15.1zm-231 7.5c-5 3.1-9.9 6.1-15.1 9l8.9 15.7c5.3-3.1 10.6-6.2 15.7-9.5zm-71.3 16.3l-12.3 13.2c5.56 5.3 12.42 8.8 19.9 10.4l4-17.5c-4.44-.9-8.59-3.1-11.6-6.1zm41 .3c-5.01 2.3-10.21 4.1-15.6 5.2l4.1 17.6c6.42-1.3 12.46-3.7 18.5-6.2zm280.3 4.8l-13.9 11.3c4.3 5.3 9.6 10.4 14.2 14l11.1-14.2c-4.4-3.4-8.2-7.5-11.4-11.1zm24.1 17.5l-4.5 17.5c7.9 1.6 13.8 2.1 21.2 1.3l-2.2-17.9c-4.9.8-9.7.3-14.5-.9z"></path>
                  </svg>
                </span>
                <span className="ml-2">
                  {estimationBefore
                    ? calculateDistanceUnit(
                        ride?.bookedEstimation?.distance,
                        ride?.distanceUnit,
                      )
                    : calculateDistanceUnit(
                        ride?.estimation?.distance,
                        ride?.distanceUnit,
                      )}
                </span>
              </p>

              <p className="flex items-center justify-center gap-3">
                <span>
                  <svg
                    stroke="currentColor"
                    fill="none"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12"></polyline>
                  </svg>
                </span>
                <span className="ml-2">
                  {estimationBefore
                    ? formatTimeFromSeconds(ride?.bookedEstimation?.time)
                    : formatTimeFromSeconds(ride?.estimation?.time)}
                </span>
              </p>

              <p className="flex items-center justify-center gap-3">
                <span>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <title>Payment</title>
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M1 4h22v4H1V4Zm0 7h22v9H1v-9Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </span>
                <div>
                  <p>
                    {ride?.currencySymbol}{" "}
                    {parseFloat(ride.invoice.payableAmount).toFixed(2)}
                  </p>
                  <p
                    className="text-gray-500 font-light "
                    style={{ fontWeight: 300, fontSize: "14px" }}
                  >
                    {" "}
                    {language?.[ride?.payment?.option] || ride?.payment?.option}
                  </p>
                </div>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const Profile = ({
  ride,
  passenger,
  driver,
  guest,
  openProfile = () => {},
  rideForSomeOne,
}) => {
  const { language } = useLanguage();
  const { theme } = useTheme();
  const { themes, currentTheme } = useThemes();
  const themeT = themes[currentTheme];
  const { imageUrlCheck } = useImage();
  const { morph, isDemo } = useUtils();
  const callSettings = useRecoilValue(callSettingsAtom);

  const isValidColor = (color) => {
    // Check for hex codes (with or without #)
    const hexRegex = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

    // List of valid CSS color names
    const validColorNames = [
      "black",
      "silver",
      "gray",
      "white",
      "maroon",
      "red",
      "purple",
      "green",
      "lime",
      "olive",
      "yellow",
      "navy",
      "blue",
      "teal",
      "aqua",
      "orange",
      "aliceblue",
      "antiquewhite",
      "aquamarine",
      "azure",
      "beige",
      "bisque",
      "brown",
      "coral",
      "crimson",
      "cyan",
      // Add more color names as needed
    ];

    return (
      hexRegex.test(color) || validColorNames.includes(color?.toLowerCase())
    );
  };

  const avatar = driver ? ride?.professional?.avatar : ride?.user?.avatar;

  const profileValues = {
    name: driver
      ? `${morph(ride?.professional?.firstName)} ${morph(ride?.professional?.lastName)}`
      : guest
        ? `${language.GUEST_USER || "-"}`
        : `${morph(ride?.user?.firstName)} ${morph(ride?.user?.lastName)}` ||
          "-",
    email: driver
      ? morph(ride?.professional?.email)
      : morph(ride?.user?.email) || "-",
  };

  const avatarName = driver
    ? morph(ride?.professional?.firstName)?.split("")
    : guest
      ? ["G"]
      : morph(ride?.user?.firstName)?.split("");

  const avatarLastName = driver
    ? morph(ride?.professional?.lastName)?.split("")
    : guest
      ? ["G"]
      : morph(ride?.user?.lastName)?.split("");

  const driverFields = [
    {
      id: 1,
      fieldName: language.PHONE,
      value: callSettings?.data?.isNeedCallMasking
        ? `${ride?.professional?.phone?.code} ${morph(ride?.professional?.phone?.number, true)}`
        : `${ride?.professional?.phone?.code} ${morph(ride?.professional?.phone?.number)}`,
    },
    {
      id: 2,
      fieldName: language.GENDER,
      value:
        ride?.professional?.gender !== null &&
        ride?.professional?.gender?.toLowerCase(),
    },
    {
      id: 3,
      fieldName: language.AGE,
      value: ` ${ride?.professional?.age}`,
    },
    {
      id: 4,
      fieldName: language.CATEGORY,
      value:
        (
          <div className="flex items-center gap-1">
            {ride?.vehicle?.vehicleCategoryImage && (
              <div
                className=" "
                style={{ width: "60px", height: "50px", marginRight: "4px" }}
              >
                <img
                  src={ride?.vehicle?.vehicleCategoryImage}
                  alt="Driver"
                  className="w-full h-full rounded-full object-contain"
                />
              </div>
            )}
            <p style={{ fontSize: "15px" }}>
              {ride?.vehicle?.vehicleCategoryName || "-"}
            </p>
          </div>
        ) || "-",
    },
    {
      id: 5,
      fieldName: language.PLATE_NUMBER,
      value: morph(ride?.vehicle?.plateNumber),
    },
    {
      id: 6,
      fieldName: language.MODEL,
      value: `${morph(ride?.vehicle?.model)}`,
    },
    {
      id: 7,
      fieldName: language.FUEL_TYPE,
      value: `${ride?.vehicle?.type?.toLowerCase()}`,
    },
    {
      id: 8,
      fieldName: language.COLOR,
      value: isValidColor(ride?.vehicle?.color) ? (
        <div className="flex justify-normal items-center gap-3">
          <div
            className={`rounded-full border ${themeT.colors.borderColor}`}
            style={{
              backgroundColor: ride.vehicle.color.toLowerCase(),
              width: "28px",
              height: "11px",
            }}
          ></div>
          <div>({ride?.vehicle?.color})</div>
        </div>
      ) : (
        ride?.vehicle?.color || "-"
      ),
    },
  ];

  const passengerFields = [
    {
      id: 1,
      fieldName: language.PHONE,
      value: callSettings?.data?.isNeedCallMasking
        ? `${ride?.user?.phone?.code} ${morph(ride?.user?.phone?.number, true)}`
        : `${ride?.user?.phone?.code} ${morph(ride?.user?.phone?.number)}`,
    },
    {
      id: 2,
      fieldName: language.GENDER,
      value:
        (ride?.user?.gender !== null && ride?.user?.gender?.toLowerCase()) ||
        "-",
    },
    // {
    //   id: 3,
    //   fieldName: language.BOOKED_BY,
    //   value: ` ${ride?.bookingBy?.toLowerCase()}` || "-",
    // },
    // {
    //   id: 4,
    //   fieldName: language.BOOKED_FROM,
    //   value: ride?.bookingFrom?.toLowerCase() || "-",
    // },
    {
      id: 5,
      fieldName: language.PAYMENT,
      value: ride?.payment?.option,
    },
  ];

  const guestFields = [
    {
      id: 1,
      fieldName: language.PHONE,
      value: callSettings?.data?.isNeedCallMasking
        ? `${ride?.bookingFor?.phoneCode} ${morph(ride?.bookingFor?.phoneNumber, true)}`
        : `${ride?.bookingFor?.phoneCode} ${morph(ride?.bookingFor?.phoneNumber)}`,
    },
    {
      id: 2,
      fieldName: language.BOOKED_BY,
      value: ` ${ride?.bookingBy?.toLowerCase()}` || "-",
    },
  ];

  const driverAmenities = [
    {
      id: 1,
      fieldName: language.SUBCATEGORY_AVAILABLE,
      value: ride?.isAcceptOtherCategory,
    },
    {
      id: 2,
      fieldName: language.IS_PET_ALLOWED,
      value: ride?.isPetAllowed,
    },
    {
      id: 3,
      fieldName: language.IS_USB_CHARGER_PORT_AVAILABLE,
      value: ride?.isHasUSBChargePort,
    },
    {
      id: 4,
      fieldName: language.IS_WIFI_AVAILABLE,
      value: ride?.isHasWifi,
    },
    {
      id: 5,
      fieldName: "Is AC Available",
      value: ride?.isHasWifi,
    },
  ];

  const subCategory = [
    {
      id: 1,
      fieldName: language.SUBCATEGORY_AVAILABLE,
      value: ride?.professional?.vehicles?.[0]?.isSubCategoryAvailable,
    },
  ];

  const fields = driver ? driverFields : guest ? guestFields : passengerFields;

  const appStateKeyPresent = driver
    ? Object.keys(ride?.professional).includes("isAppQuitted")
    : ride?.user && Object?.keys(ride?.user)?.includes("isAppQuitted");

  const appState = driver
    ? ride?.professional?.isAppQuitted
    : ride?.user?.isAppQuitted;

  return (
    <section className="w-full h-full lg:h-full lg:px-8  px-5 mt-7 lg:mt-7 pb-20 lg:pb-0">
      <div className="flex justify-between w-full items-center">
        <p className=" font-bold text-xl ">
          {driver
            ? language.DRIVER
            : rideForSomeOne
              ? language.BOOKINGS + " " + language.USER
              : language?.PASSENGER}
        </p>
      </div>
      <div className="space-y-6">
        <div className="flex items-center gap-3 mt-4 cursor-pointer">
          <div className="" style={{ position: "relative" }}>
            {imageUrlCheck(avatar) && !isDemo ? (
              <div
                className={`border-2 border-white rounded-full ${themeT.colors.dashBoardShadow}`}
                style={{
                  width: "80px",
                  height: "80px",
                  marginRight: "15px",
                }}
              >
                <img
                  src={avatar}
                  alt="Driver"
                  className="w-full h-full rounded-full object-cover"
                />
              </div>
            ) : (
              <div
                className=" bg-gray-200 relative rounded-full flex justify-center items-center"
                style={{
                  width: ride?.guestType === "GUESTUSER" ? "60px" : "80px",
                  height: ride?.guestType === "GUESTUSER" ? "60px" : "80px",
                  marginRight: "15px",
                }}
              >
                {avatarName?.[0] ? (
                  <p className=" uppercase font-bold text-2xl">
                    {avatarName?.[0] + avatarLastName?.[0]}
                  </p>
                ) : (
                  <p className=" capitalize font-bold text-2xl">{"🚫"}</p>
                )}
              </div>
            )}
            {driver && (
              <div
                className={`h-4 w-4 border-[2px] border-white rounded-full ${
                  ride?.professional?.onlineStatus
                    ? "bg-green-600"
                    : "bg-red-500"
                } absolute bottom-1 right-5 ${themeT.colors.dashBoardShadow}`}
              ></div>
            )}
          </div>
          <div>
            <div
              className="flex items-center  font-medium capitalize"
              style={{ fontSize: "15.5px" }}
            >
              <p className=" capitalize">{profileValues?.name}</p>
              {driver && ride?.nationalIdNo && (
                <p className="rounded-full border ml-2 border-blue-600 text-sm px-3 py-1 text-blue-600">
                  {language.VERIFIED}
                </p>
              )}
            </div>

            {ride?.guestType !== "GUESTUSER" && (
              <p className=" " style={{ fontSize: "13px" }}>
                {profileValues?.email}
              </p>
            )}
            <div className="flex flex-wrap justify-normal items-center gap-2 mt-2">
              {ride?.guestType !== "GUESTUSER" && (
                <div className="  text-xs">
                  <StarRating
                    showAsNumber
                    number={
                      driver
                        ? parseFloat(
                            ride?.professional?.review?.avgRating,
                          ).toFixed(2)
                        : parseFloat(ride?.user?.review?.avgRating)
                    }
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div
          className={`grid ${
            ride?.bookingStatus === "ENDED"
              ? "lg:grid-cols-2 grid-cols-2"
              : ride?.professional && (ride?.user || ride?.guestType)
                ? "lg:grid-cols-2 grid-cols-2"
                : "lg:grid-cols-2 grid-cols-2"
          }  gap-6`}
        >
          {fields?.map((d, i) => (
            <div key={i}>
              <p className=" font-extralight text-sm capitalize">
                {d?.fieldName}
              </p>
              <p
                className="font-semibold mt-1 capitalize"
                style={{ fontSize: "15px" }}
              >
                {d?.value || "-"}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const CommonUI = ({ title, desc, id, ride }) => {
  const settings = useRecoilValue(settingsAtom);
  const { language } = useLanguage();
  const { theme } = useTheme();
  const { themes, currentTheme } = useThemes();
  const themeT = themes[currentTheme];
  const handleCall = (e) => {
    e.preventDefault();
    if (id === 1) {
      window.open(`tel:${settings?.callCenterPhone}`);
    }
    if (id === 2) {
      window.open(
        `tel:${ride?.professional?.phone?.code}${ride?.professional?.phone?.number} `,
      );
    }
    if (id === 3) {
      window.location.href = `https://wa.me/918667213477?${settings?.callCenterPhone}text=Hello`;
    }
  };

  return (
    <div className="flex flex-col justify-center items-center gap-2 text-sm w-full px-5">
      <span
        className={`${themeT.colors.darkerActiveBg} text-white rounded-full p-3`}
      >
        <svg
          stroke="currentColor"
          fill="currentColor"
          strokeWidth="0"
          viewBox="0 0 512 512"
          height="25"
          width="25"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M478.94 370.14c-5.22-5.56-23.65-22-57.53-43.75-34.13-21.94-59.3-35.62-66.52-38.81a3.83 3.83 0 0 0-3.92.49c-11.63 9.07-31.21 25.73-32.26 26.63-6.78 5.81-6.78 5.81-12.33 4-9.76-3.2-40.08-19.3-66.5-45.78s-43.35-57.55-46.55-67.3c-1.83-5.56-1.83-5.56 4-12.34.9-1.05 17.57-20.63 26.64-32.25a3.83 3.83 0 0 0 .49-3.92c-3.19-7.23-16.87-32.39-38.81-66.52-21.78-33.87-38.2-52.3-43.76-57.52a3.9 3.9 0 0 0-3.89-.87 322.35 322.35 0 0 0-56 25.45A338 338 0 0 0 33.35 92a3.83 3.83 0 0 0-1.26 3.74c2.09 9.74 12.08 50.4 43.08 106.72 31.63 57.48 53.55 86.93 100 133.22S252 405.21 309.54 436.84c56.32 31 97 41 106.72 43.07a3.86 3.86 0 0 0 3.75-1.26A337.73 337.73 0 0 0 454.35 430a322.7 322.7 0 0 0 25.45-56 3.9 3.9 0 0 0-.86-3.86z" />
        </svg>
      </span>

      <p className="text-lg font-semibold">{title}</p>
      <p className="text-sm px-6 text-center font-light">{desc}</p>

      <button
        type="button"
        aria-label="call"
        onClick={handleCall}
        className={`${themeT.colors.darkerActiveBg} text-white rounded-full px-4 py-2 w-full mt-5 mb-10 active:scale-95 transition-all duration-300 cursor-pointer`}
      >
        <span className="text-lg font-semibold">{language.CALL}</span>
      </button>
    </div>
  );
};

const ContactSection = ({ ride }) => {
  const settings = useRecoilValue(settingsAtom);
  const { language } = useLanguage();
  const { theme } = useTheme();
  const { themes, currentTheme } = useThemes();
  const themeT = themes[currentTheme];
  const callSettings = useRecoilValue(callSettingsAtom);

  return (
    <div className="py-10 lg:px-8 lg:mt-7">
      {
        // !(
        //   A.HOST === "flixmobi" ||
        //   ride?.bookingStatus === "ENDED" ||
        //   ride?.bookingStatus === "USERCANCELLED" ||
        //   ride?.bookingStatus === "PROFESSIONALCANCELLED" ||
        //   ride?.bookingStatus === "USERDENY" ||
        //   ride?.bookingStatus === "EXPIRED" ||
        //   ride?.bookingStatus === "AWAITING"
        // ) &&
        A.HOST !== "flixmobi" && callSettings?.data?.isNeedCallMasking && (
          <CommonUI
            id={1}
            title={language.CALL_SUPPORT || "Call Support"}
            desc={
              language.CALL_SUPPORT_DESC ||
              "You can tap the Call button to connect with Customer Support via a phone call."
            }
          />
        )
      }

      {
        // !(
        //   A.HOST === "flixmobi" ||
        //   ride?.bookingStatus === "ENDED" ||
        //   ride?.bookingStatus === "USERCANCELLED" ||
        //   ride?.bookingStatus === "PROFESSIONALCANCELLED" ||
        //   ride?.bookingStatus === "USERDENY" ||
        //   ride?.bookingStatus === "EXPIRED" ||
        //   ride?.bookingStatus === "AWAITING"
        // ) &&
        A.HOST !== "flixmobi" && !callSettings?.data?.isNeedCallMasking && (
          <CommonUI
            id={2}
            ride={ride}
            title={language.CALL_DRIVER || "Call Driver"}
            desc={
              language.CALL_DRIVER_DESC ||
              "You can tap the Call button to connect with Driver via a phone call."
            }
          />
        )
      }

      {
        // A.HOST === "flixmobi" &&
        //   !(
        //     ride?.bookingStatus === "ENDED" ||
        //     ride?.bookingStatus === "USERCANCELLED" ||
        //     ride?.bookingStatus === "PROFESSIONALCANCELLED" ||
        //     ride?.bookingStatus === "USERDENY" ||
        //     ride?.bookingStatus === "EXPIRED" ||
        //     ride?.bookingStatus === "AWAITING"
        //   )
        A.HOST === "flixmobi" && (
          <CommonUI
            id={3}
            ride={ride}
            title={language.CALL_WHATSAPP || "Call Support"}
            desc={
              language.CALL_WHATSAPP_DESC ||
              "You can tap the Call button to connect with support via a phone call."
            }
          />
        )
      }
    </div>
  );
};

const Popview = () => {
  const { id } = useParams();
  const settings = useRecoilValue(settingsAtom);
  const { language } = useLanguage();
  const { theme } = useTheme();
  const { themes, currentTheme } = useThemes();
  const themeT = themes[currentTheme];
  const { morph } = useUtils();
  const callSettings = useRecoilValue(callSettingsAtom);
  //
  const [hideHeader, setHideHeader] = useState(false);
  const [loading, setLoading] = React.useState(true);
  const [ride, setRide] = React.useState({});
  const [initialBookingStatus, setInitialBookingStatus] = useState(null);
  const [refreshing, setRefreshing] = React.useState(false);
  const [distanceTypeUnitValue, setDistanceTypeUnitValue] =
    React.useState(1000);
  const [distanceType, setDistanceType] = React.useState("");
  const [tollsData, setTollsData] = useState([]);
  const [popup, setPopup] = React.useState(null);
  const [liveData, setLiveData] = useState();
  const [onGoingWayData, setOnGoingWayData] = useState([]);
  const [onGoingWayDataAfterPicked, setOnGoingWayDataAfterPicked] = useState(
    [],
  );
  const [switchValue, setSwitchValue] = useState(false);
  //
  const fetchDriver = async () => {
    try {
      const { data } = await axios.get(A.HOST + A.TRACK + "/" + id);
      setRide(data);
      setInitialBookingStatus(data?.bookingStatus);
      setRefreshing(false);
      setDistanceTypeUnitValue(data.category.distanceTypeUnitValue);
      setDistanceType(data.category.distanceType);
    } catch (err) {
      console.log(err, "error in getting ride details");
      setRefreshing(false);
    }
    setLoading(false);
  };

  React.useEffect(() => {
    if (id) {
      fetchDriver();
    } else {
      setLoading(false);
    }
  }, [id, refreshing]);

  React.useEffect(() => {
    if (liveData) {
      if (liveData?.bookingStatus !== initialBookingStatus) {
        fetchDriver();
      }
    }
  }, [liveData]);

  React.useEffect(() => {
    if (!liveData) return;

    const newPoint = { lat: liveData?.lat, lng: liveData?.lng };
    const acceptLatLng = {
      lat: ride.activity.acceptLatLng?.lat,
      lng: ride.activity.acceptLatLng?.lng,
    };
    const pickUpLatLng = {
      lat: ride.activity.pickUpLatLng?.lat,
      lng: ride.activity.pickUpLatLng?.lng,
    };

    if (ride.bookingStatus !== "STARTED") {
      // Before ride starts, track path until pickup point is reached
      setOnGoingWayData((prev = []) => {
        return [
          acceptLatLng,
          ...(prev.length > 0 ? prev : liveData?.pickupWayData || []),
          newPoint,
        ];
      });
    } else {
      // After ride starts, update paths
      setOnGoingWayData(() => {
        // Only include acceptLatLng in the path if it's valid
        const startPoint =
          acceptLatLng || liveData?.pickupWayData?.[0] || pickUpLatLng;
        return [startPoint, ...(liveData?.pickupWayData || []), pickUpLatLng];
      });

      setOnGoingWayDataAfterPicked((prev) => {
        const startPoint = pickUpLatLng;
        const data =
          liveData?.manualWayData.length > 0 ? liveData?.manualWayData : prev;
        return liveData?.manualWayData.length > 0
          ? [startPoint, ...data, newPoint]
          : prev?.length > 0
            ? [startPoint, ...data, newPoint]
            : [newPoint];
      });
    }
  }, [liveData]);

  //
  const rideForSomeOne =
    ride?.bookingFor?.phoneNumber !== ride?.user?.phone?.number;

  const rightContent = () => {
    return (
      <div
        className={`${"flex flex-wrap gap-4 mt-1 lg:mt-0 justify-normal lg:justify-normal w-full lg:w-fit items-center xl:pr-0 2xl:pr-0"}`}
        style={{ gap: "20px" }}
      >
        {ride?.bookingStatus === "ENDED" && (
          <div
            className=" flex items-center gap-3 "
            style={{ fontSize: "16px" }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <title>Payment</title>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 4h22v4H1V4Zm0 7h22v9H1v-9Z"
                fill="currentColor"
              ></path>
            </svg>
            <div>
              <p className="flex justify-normal items-center gap-2 font-semibold">
                {ride?.currencySymbol}
                {parseFloat(ride.invoice.payableAmount).toFixed(2)}
              </p>
              <p
                className=" font-light "
                style={{ fontWeight: 300, fontSize: "14px" }}
              >
                {" "}
                {language[ride?.payment?.option] || ride?.payment?.option}
              </p>
            </div>
          </div>
        )}
        <div
          className="rounded-full border"
          style={{
            borderColor:
              ride?.bookingStatus === "USERCANCELLED" ||
              ride?.bookingStatus === "PROFESSIONALCANCELLED" ||
              ride?.bookingStatus === "EXPIRED" ||
              ride?.bookingStatus === "USERDENY"
                ? "#e53935"
                : "#50C878",
            color:
              ride?.bookingStatus === "USERCANCELLED" ||
              ride?.bookingStatus === "PROFESSIONALCANCELLED" ||
              ride?.bookingStatus === "EXPIRED" ||
              ride?.bookingStatus === "USERDENY"
                ? "#d32f2f"
                : "#50C878",
            padding: "8px 15px",
            width: "fit-content",
            fontSize: "15px",
          }}
        >
          <p>
            {ride?.bookingStatus === "AWAITING"
              ? language.REQUESTING
              : ride?.bookingStatus === "PROFESSIONALCANCELLED" &&
                  ride?.activity?.cancelledBy?.userType === "ADMIN"
                ? language.ADMIN?.toLocaleUpperCase() +
                  " " +
                  language.CANCELLED?.toLocaleUpperCase()
                : language[ride?.bookingStatus] || ride?.bookingStatus}
          </p>
        </div>
      </div>
    );
  };

  if (!ride?._id && !loading) {
    return (
      <div className="">
        <NotFound rideIdUndefined />
      </div>
    );
  }

  return loading || !settings?.mapApi?.web ? (
    <SmallLoader />
  ) : (
    <>
      {/* only some status only have trigger track api */}
      {!(
        ride?.bookingStatus === "ENDED" ||
        ride?.bookingStatus === "USERCANCELLED" ||
        ride?.bookingStatus === "PROFESSIONALCANCELLED" ||
        ride?.bookingStatus === "USERDENY" ||
        ride?.bookingStatus === "EXPIRED" ||
        ride?.bookingStatus === "AWAITING"
      ) && (
        <TrackingMap
          noMap
          sendLiveData={(data) => {
            setLiveData(data);
          }}
          user={false}
          professional={false}
          responseOfficer={false}
          rideId={ride._id}
        />
      )}

      <section
        className={`lg:flex justify-between lg:px-6 xl:px-10 px-6 lg:pt-4 lg:pb-4 py-3 font-bold border-b mb-5  2xl:px-36 fixed top-0 z-10 w-full ${themeT.colors.blocksBg} ${hideHeader ? " hidden lg:block" : "block"}`}
      >
        <div className="xl:flex xl:justify-between xl:w-5/12 xl:items-center ">
          <div className="flex justify-normal items-center lg:gap-6 gap-3 text-lg ">
            <div className="border rounded-full p-2">
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 512 512"
                height="18"
                width="18"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"></path>
              </svg>
            </div>
            <div className="flex justify-normal gap-3 items-center">
              {ride?.bookingId} <CopyButton textToCopy={ride?.bookingId} />
            </div>
            <div className="text-sm">
              <RefreshButton
                onClick={() => setRefreshing(true)}
                loading={refreshing}
              />
            </div>
          </div>
        </div>

        <div className="hidden lg:block">{rightContent()}</div>
      </section>

      <section className="lg:flex pt-0 lg:pt-[100px]">
        <section className="w-full min-w-full">
          <GoogleMapComponent
            hideHeader={(e) => setHideHeader(e)}
            mobile
            value={ride}
            liveData={liveData}
            onGoingWayData={onGoingWayData}
            onGoingWayDataAfterPicked={onGoingWayDataAfterPicked}
            driverProfile={
              ride?.professional && (
                <section>
                  <Profile ride={ride} driver />
                </section>
              )
            }
            estimation={
              ride?.bookingStatus !== "ENDED" ? (
                <EstimationDetails ride={ride} estimationBefore />
              ) : (
                <EstimationDetails
                  switchValue={switchValue}
                  ride={ride}
                  estimationAfter
                />
              )
            }
            contactSection={<ContactSection ride={ride} />}
            passengerProfile={
              ride?.guestType === "GUESTUSER" ? (
                <section>
                  <Profile ride={ride} guest />
                </section>
              ) : (
                ride?.user && (
                  <section className="">
                    <Profile rideForSomeOne={rideForSomeOne} ride={ride} />
                  </section>
                )
              )
            }
          />
        </section>
      </section>
    </>
  );
};

export default Popview;
